import { defineStore } from "pinia";
import { Status } from "@/models/Status";

export const useStatusStore = defineStore("statusStore", {
  state: () => ({
    status: new Status(),
  }),
  // SUCCESS = 1, ERROR = 2, WARNING = 3, NOTICE = 4
  actions: {
    success(msg: string): void {
      this.status.stat = 1;
      this.status.msg = msg;
    },
    warning(msg: string): void {
      this.status.stat = 3;
      this.status.msg = msg;
    },
    error(msg: string): void {
      this.status.stat = 2;
      this.status.msg = msg;
    },
    clear() {
      this.status.stat = 0;
      this.status.msg = "";
    },
  },
  persist: true,
});
